import { API_BASE_URL } from "@/lib/queryClient";

export type LeadPayload = {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message?: string;
  source?: string;
  investorType?: string;
  investmentRange?: string;
  aum?: string;
  yieldTarget?: string;
};

export type LeadResponse = {
  emailStatus?: "sent" | "failed";
  message?: string;
};

/** Submit a public inquiry via the backend (Resend email + DB). Avoids EmailJS browser CORS. */
export async function submitLead(data: LeadPayload): Promise<LeadResponse> {
  const url = API_BASE_URL ? `${API_BASE_URL}/api/leads` : "/api/leads";
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  let body: LeadResponse & { message?: string } = {};
  try {
    body = await res.json();
  } catch {
    /* non-JSON error body */
  }

  if (!res.ok) {
    throw new Error(body.message || "Failed to submit inquiry");
  }

  return body;
}
